export interface PriceRange {
  min: number | null;
  max: number | null;
}

/**
 * Filter state model for brand and price filter interaction.
 * Implements the design document specification for consistent filter behavior.
 */
export interface FilterState {
  selectedBrands: number[] | null;  // null or [] = "all brands"
  priceMinInput: number | null;     // raw user input
  priceMaxInput: number | null;
  priceRangeApplied: [number, number]; // normalized, applied to query
}

/**
 * Extended price range with catalog and brand-specific bounds.
 * Used to properly constrain and clamp price filters based on brand selection.
 */
export interface PriceBounds {
  catalogMinPrice: number;
  catalogMaxPrice: number;
  brandMinPrice: number;
  brandMaxPrice: number;
}

/**
 * Clamp a value between min and max bounds.
 */
export function clampValue(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

/**
 * Clamp and validate a price range within bounds.
 * If min > max after clamping, reset to full bounds.
 */
export function clampPriceRange(
  appliedMin: number,
  appliedMax: number,
  boundMin: number,
  boundMax: number
): [number, number] {
  let newMin = clampValue(appliedMin, boundMin, boundMax);
  let newMax = clampValue(appliedMax, boundMin, boundMax);
  
  // If clamping makes min > max, reset to full range
  if (newMin > newMax) {
    return [boundMin, boundMax];
  }
  
  return [newMin, newMax];
}
